import { Typography } from "antd";

interface TextDisplayParams {
    header?: string;
    text: string;
}

const TextDisplay = ({
    header,
    text,
}: TextDisplayParams) => {
    return (
        <div>
            {header && <Typography.Title level={4}>{header}</Typography.Title>}
            <Typography>{text}</Typography>
        </div>
    );
};

export default TextDisplay;
